import http from '../../base/http';

class UserAct {

	constructor(param={activityId:0,userToken:""}) {
        this.param = param;
        this.actData = {}; // 存储用户信息 {活动ID：活动信息}
    }
    getUserActInfo(){
    	let promise = $.Deferred();
    	let param = {};
    	let promiseGetData = http.fetch({
            url: UpAct.CONFIG.getActStatus(),
            data:this.param
        });
        promiseGetData.done((res)=>{
        	if (res.errcode == 0) {
                let rewardData = this.parseActInfo(res.data);

                promise.resolve(rewardData);
            } else {
                promise.reject(res);
            }

        });
        promiseGetData.fail((res) => {
            promise.reject(res);
        });
        return promise;
    }
    parseActInfo(data){
        let taskActInfo = {};
        let keysArr = [];
        keysArr = data.status ? Object.keys(data.status):[];
        if(keysArr.length > 0){
            $.map(data.status,function(item,index){
                

                item.serverTime = data.serverTime;
                taskActInfo[item.activityId] = item;
            })

        }else {
            /**test*/
            // data.rewardList.toreward = 10;
            taskActInfo[data.activityId] = data;
        }
        return taskActInfo;

    }
    doExchange(){
        let promise = $.Deferred();
        let param = {};
        let promiseGetData = http.fetch({
            url: UpAct.CONFIG.doExchange(),
            data:this.param,
            type:'POST'
        });
        promiseGetData.done((res)=>{
            if (res.errcode == 0) {
                promise.resolve(res);
            } else {
                promise.reject(res);
            }

        });
        promiseGetData.fail((res) => {
            promise.reject(res);
        });
        return promise;
    }
}
module.exports = UserAct;


// WEBPACK FOOTER //
// ./js/component/base/useract.js